import { lazy } from 'react-router-guard';
import { getRoutePrefix } from '../services/helpers';
import { mustAuth, mustUnAuth } from './guards'


export default [
    {
        path: getRoutePrefix('/login'),
        exact: true,
        component: lazy(() => import('../screens/Auth/AuthUpdated.ui')),
        canActivate: [mustUnAuth],
    },

    {
        path: getRoutePrefix('/'),
        component: lazy(() => import('../screens/main/MainUpdated.ui')),
        routes: [
            {
                path: getRoutePrefix('/change-password'),
                exact: true,
                component: lazy(() => import('../screens/change-password/ChangePasswordPage.ui')),
            },
            {
                path: getRoutePrefix('/claims'),
                exact: true,
                component: lazy(() => import('../screens/claims/Claims.ui')),
            },
            {
                path: getRoutePrefix('/summary-report'),
                exact: true,
                component: lazy(() => import('../screens/summary-report/SummaryReport.ui')),
            },
            {
                path: getRoutePrefix('/reports-and-analytics'),
                exact: true,
                component: lazy(() => import('../screens/reports/ReportsAndAnalytics.ui')),
            },
            {
                path: getRoutePrefix('/archive/claims'),
                exact: true,
                component: lazy(() => import('../screens/claims/ArchivedClaims.ui')),
            },
            {
                path: getRoutePrefix('/reports/compare-garage-prices'),
                exact: true,
                component: lazy(() => import('../screens/reports/ui/CompareGaragePricesReport.ui')),
            },
            {
                path: getRoutePrefix('/reports/statistics'),
                exact: true,
                component: lazy(() => import('../screens/reports/ui/Statistics.ui'))
            },
            {
                path: getRoutePrefix('/reports/parts-supply-evaluations'),
                exact: true,
                component: lazy(() => import('../screens/reports/ui/PartsSupplyEvaluationsReport.ui')),
            },
            {
                path: getRoutePrefix('/reports/commitments'),
                exact: true,
                component: lazy(() => import('../screens/reports/ui/Commitments.ui'))
            },
            {
                path: getRoutePrefix('/reports/sellers-evaluations'),
                exact: true,
                component: lazy(() => import('../screens/reports/ui/SellersEvaluations.ui')),
            },
            {
                path: getRoutePrefix('/reports/external-loss-adjustings'),
                exact: true,
                component: lazy(() => import('../screens/reports/ui/ExternalLossAdjustings')),
            },
            {
                path: getRoutePrefix('/claim/:claimId/edit'),
                exact: true,
                component: lazy(() => import('../screens/board-monitor/BoardMonitorUpdated.ui')),

            },
            {
                path: getRoutePrefix('/archive/claim/:claimId/edit'),
                exact: true,
                component: lazy(() => import('../screens/claims/ArchivedClaims.ui')),
            },
            {
                path: getRoutePrefix('/seller_claims'),
                exact: true,
                component: lazy(() => import('../screens/seller-dashboard/seller-claims/SellerClaims.ui')),

            },
            {
                path: getRoutePrefix('/sent_price_offers'),
                exact: true,
                component: lazy(() => import('../screens/seller-dashboard/seller-claims/components/SentPriceOffers.ui')),
            },
            {
                path: getRoutePrefix('/price_offers_reports'),
                exact: true,
                component: lazy(() => import('../screens/seller-dashboard/seller-claims/components/SellerPriceOffersReport.ui')),
            },
            {
                path: getRoutePrefix('/purchase_orders'),
                exact: true,
                component: lazy(() => import('../screens/seller-dashboard/seller-claims/components/FirstPurchaseOrders.ui')),
            },
            {
                path: getRoutePrefix('/payments'),
                exact: true,
                component: lazy(() => import('../screens/seller-dashboard/seller-claims/components/SubscriptionsPayments.ui')),
            },
            {
                path: '/',
                redirect: getRoutePrefix('/claims') ,
            }
        ],
        canActivate: [mustAuth],
    },


];

